import {
  SnippetElement,
  defineElement,
  on,
  onClick,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/common-product-card/common-product-card.ts
var CommonProductCard = class extends SnippetElement {
  handleAccordionClick(elm) {
    const index = parseInt(elm.dataset.openButton);
    if (this.accordions[index].isOpen) {
      this.close(index);
    } else {
      this.closeAll();
      this.open(index);
    }
  }
  handleAccordionKeyDown(button, event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.handleAccordionClick(button);
    }
  }
  open(index) {
    this.accordions[index].open();
    this.chevrons[index].classList.add("rotate-180");
  }
  close(index) {
    this.accordions[index].close();
    this.chevrons[index].classList.remove("rotate-180");
  }
  closeAll() {
    this.accordions.forEach((accordion, index) => {
      this.close(index);
    });
  }
  connectedCallback() {
    return __async(this, null, function* () {
    });
  }
};
__decorateClass([
  queryAll("[data-text]")
], CommonProductCard.prototype, "texts", 2);
__decorateClass([
  queryAll("[data-title]")
], CommonProductCard.prototype, "titles", 2);
__decorateClass([
  queryAll("[data-accordion]")
], CommonProductCard.prototype, "accordions", 2);
__decorateClass([
  queryAll("[data-chevron]")
], CommonProductCard.prototype, "chevrons", 2);
__decorateClass([
  onClick("[data-open-button]")
], CommonProductCard.prototype, "handleAccordionClick", 1);
__decorateClass([
  on("keydown", "[data-open-button]")
], CommonProductCard.prototype, "handleAccordionKeyDown", 1);
CommonProductCard = __decorateClass([
  defineElement("common-product-card")
], CommonProductCard);
export {
  CommonProductCard
};
